document.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded");
  document.querySelectorAll(".sponsorships_form").forEach((formElem) => {
    formElem
      .querySelectorAll("select.sponsorship_id_to_copy_selector")
      .forEach((elem_) => {
        const elem = elem_ as HTMLSelectElement;
        elem.addEventListener("change", () => {
          const query = new URLSearchParams(location.search);
          query.set("sponsorship_id_to_copy", elem.value);
          location.search = query.toString();
        });
      });

    formElem
      .querySelectorAll(".sponsorships_form_billing_contact")
      .forEach((elem) => {
        const checkbox = elem.querySelector(
          ".form-check input[type=checkbox]",
        ) as HTMLInputElement;
        const fieldset = elem.querySelector("fieldset") as HTMLFieldSetElement;

        const handleChange = (e?: Event) => {
          if (checkbox.checked) {
            fieldset.classList.remove("d-none");
            fieldset.disabled = false;
          } else {
            fieldset.classList.add("d-none");
            fieldset.disabled = true;
          }
        };
        checkbox.addEventListener("change", handleChange);
        checkbox.addEventListener("click", handleChange);
        handleChange();
      });

    const calculateTotalAttendees = () => {
      const totalElem = formElem.querySelector(
        ".sponsorships_form_tickets__total",
      ) as Element;
      if (!totalElem) return;

      const selectedPlanElem = formElem.querySelector(
        ".sponsorships_form_plans input[type=radio]:checked",
      ) as HTMLInputElement;
      const ticketsIncludedInPlanElem = formElem.querySelector(
        ".sponsorships_form_tickets__included_in_plan",
      )! as Element;
      const additionalAttendeesElem = formElem.querySelector(
        ".sponsorships_form_tickets__additional_attendees input",
      )! as HTMLInputElement;

      const numberOfGuests = selectedPlanElem
        ? parseInt(selectedPlanElem.dataset["guests"]!, 10)
        : 0;
      const additionalAttendees = additionalAttendeesElem.valueAsNumber;

      const total =
        numberOfGuests + (isNaN(additionalAttendees) ? 0 : additionalAttendees);

      ticketsIncludedInPlanElem.innerHTML = `${numberOfGuests}`;
      totalElem.innerHTML = `${total}`;
    };
    formElem
      .querySelectorAll(
        ".sponsorships_form_tickets__additional_attendees input",
      )
      .forEach((elem) => {
        elem.addEventListener("change", () => calculateTotalAttendees());
        elem.addEventListener("click", () => calculateTotalAttendees());
      });
    calculateTotalAttendees();

    formElem.querySelectorAll(".sponsorships_form_plans").forEach((elem) => {
      const boothCheckbox = formElem.querySelector(
        ".sponsorships_form_booth_request input[type=checkbox]",
      ) as HTMLInputElement;
      const uneligibleHelpTextElem = formElem.querySelector(
        ".sponsorships_form_booth_request_uneligible",
      ) as Element;
      const jobBoardSection = formElem.querySelector<HTMLElement>(
        ".sponsorships_form_job_board",
      );
      const jobBoardUneligibleElem = formElem.querySelector<HTMLElement>(
        ".sponsorships_form_job_board_uneligible",
      );
      const jobBoardInputs = jobBoardSection?.querySelectorAll<
        HTMLInputElement | HTMLTextAreaElement
      >("input, textarea");
      const customizationRequestField = document.querySelector(
        ".sponsorships_form_customization_request",
      ) as HTMLTextAreaElement;
      const profileFieldHelpElem = document.querySelector(
        ".sponsorships_form_profile_help",
      ) as Element;
      const acceptanceHelpElem = document.querySelector(
        ".sponsorships_acceptance_help",
      ) as Element;

      const handleChange = (e: HTMLInputElement | null) => {
        if (e?.dataset.booth == "1") {
          uneligibleHelpTextElem.classList.add("d-none");
          boothCheckbox.disabled = false;
        } else {
          uneligibleHelpTextElem.classList.remove("d-none");
          boothCheckbox.checked = false;
          boothCheckbox.disabled = true;
        }

        if (jobBoardSection) {
          if (e?.dataset.jobBoard == "1") {
            jobBoardUneligibleElem?.classList.add("d-none");
            jobBoardInputs?.forEach((input) => {
              input.disabled = false;
            });
          } else {
            jobBoardUneligibleElem?.classList.remove("d-none");
            jobBoardInputs?.forEach((input) => {
              input.value = "";
              input.disabled = true;
            });
          }
        }

        const wordsLimitHelp = e?.dataset.wordsLimitHelp;
        if (wordsLimitHelp) {
          profileFieldHelpElem.innerHTML = wordsLimitHelp;
        } else {
          profileFieldHelpElem.innerHTML = "";
        }

        const acceptanceHelp = e?.dataset.acceptanceHelp;
        if (acceptanceHelp) {
          acceptanceHelpElem.innerHTML = acceptanceHelp;
        } else {
          acceptanceHelpElem.innerHTML = "";
        }

        customizationRequestField.required = e?.dataset["other"] == "1";
      };
      handleChange(
        elem.querySelector("input[type=radio]:checked") as HTMLInputElement,
      );

      elem.querySelectorAll("input[type=radio]").forEach((planRadioElem) => {
        const planRadio = planRadioElem as HTMLInputElement;
        planRadio.addEventListener("change", (e) => {
          calculateTotalAttendees();
          handleChange(e.target as HTMLInputElement);
        });
      });
    });

    formElem
      .querySelectorAll<HTMLElement>(
        ".sponsorships_form_fallback_section",
      )
      .forEach((section) => {
        const fallbackOptionSelect = section.querySelector<HTMLSelectElement>(
          'select[name="sponsorship[fallback_option]"]',
        );
        if (!fallbackOptionSelect) return;

        const updateFallbackOptions = () => {
          const selectedPlanElem = formElem.querySelector<HTMLInputElement>(
            ".sponsorships_form_plans input[type=radio]:checked",
          );
          const boothCheckbox = formElem.querySelector<HTMLInputElement>(
            ".sponsorships_form_booth_request input[type=checkbox]",
          );

          const boothRequested = boothCheckbox?.checked || false;
          const selectedPlanName = selectedPlanElem?.dataset.planName;

          let visibleCount = 0;

          Array.from(fallbackOptionSelect.options).forEach((option) => {
            if (option.value === "") {
              // Handle blank option separately at the end
              return;
            }

            const conditionsStr = option.dataset.conditions;
            let shouldShow = false;

            if (conditionsStr) {
              try {
                const conditions = JSON.parse(conditionsStr);
                // OR logic: if ANY condition matches, show the option
                shouldShow = conditions.some(
                  (condition: {
                    plans?: string[];
                    booth_request?: boolean;
                  }) => {
                    // AND logic: ALL attributes in a condition must match
                    let matches = true;

                    if (condition.booth_request !== undefined) {
                      matches =
                        matches && boothRequested === condition.booth_request;
                    }

                    if (condition.plans && condition.plans.length > 0) {
                      matches =
                        matches &&
                        selectedPlanName !== undefined &&
                        condition.plans.includes(selectedPlanName);
                    }

                    return matches;
                  },
                );
              } catch (e) {
                console.error("Failed to parse conditions data", e);
              }
            } else {
              // No conditions means always show
              shouldShow = true;
            }

            option.hidden = !shouldShow;
            if (shouldShow) {
              visibleCount++;
            }
            if (!shouldShow && option.selected) {
              // If current selection is hidden, reset to blank
              fallbackOptionSelect.value = "";
            }
          });

          // Control section visibility and required attribute
          const blankOption = Array.from(fallbackOptionSelect.options).find(
            (opt) => opt.value === "",
          );

          if (visibleCount > 0) {
            section.classList.remove("d-none");
            fallbackOptionSelect.required = true;
            if (blankOption) blankOption.hidden = true;
          } else {
            section.classList.add("d-none");
            fallbackOptionSelect.required = false;
            if (blankOption) blankOption.hidden = false;
          }
        };

        const updatePriorityHuman = () => {
          const priorityListSection = formElem.querySelector<HTMLElement>(
            ".sponsorships_form_fallback_priority",
          );
          if (!priorityListSection) return;
          const priorityList = priorityListSection.querySelector("ol");
          if (!priorityList) return;

          const selectedOption = fallbackOptionSelect.selectedOptions[0];
          if (!selectedOption || selectedOption.value === "") {
            priorityList.innerHTML = "";
            return;
          }

          const priorityHumanStr = selectedOption.dataset.priorityHuman || "[]";
          const priorityHuman = JSON.parse(priorityHumanStr) as string[];

          const selectedPlanElem = formElem.querySelector<HTMLInputElement>(
            ".sponsorships_form_plans input[type=radio]:checked",
          );
          const selectedPlanName = selectedPlanElem?.dataset.planName || "";

          const boothCheckbox = formElem.querySelector<HTMLInputElement>(
            ".sponsorships_form_booth_request input[type=checkbox]",
          );
          priorityHuman.unshift(
            `{plan}${
              boothCheckbox?.disabled
                ? ""
                : `!${boothCheckbox?.checked ? "booth" : "no_booth"}`
            }`,
          );

          const locales = {
            withdraw: section.dataset.localeWithdraw || "!withdraw",
            no_booth: section.dataset.localeNoBooth || "!no_booth",
            booth: section.dataset.localeBooth || "!booth",
          };

          priorityList.innerHTML = priorityHuman
            .map((item) => {
              let displayItem = item.replace("{plan}", selectedPlanName);

              displayItem = displayItem
                .replace(/!no_booth/g, ` (${locales.no_booth})`)
                .replace(/!booth/g, ` (${locales.booth})`)
                .replace(/!withdraw/g, `${locales.withdraw}`);

              return `<li>${displayItem}</li>`;
            })
            .join("");

          priorityListSection.classList.remove("d-none");
        };

        updateFallbackOptions();
        updatePriorityHuman();

        fallbackOptionSelect.addEventListener("change", updatePriorityHuman);

        formElem
          .querySelectorAll<HTMLInputElement>(
            ".sponsorships_form_plans input[type=radio]",
          )
          .forEach((planRadio) => {
            planRadio.addEventListener("change", () => {
              // Reset fallback option to remind user to select again
              fallbackOptionSelect.value = "";
              const prioritySection = formElem.querySelector<HTMLElement>(
                ".sponsorships_form_fallback_priority",
              );
              prioritySection?.classList.add("d-none");
              updateFallbackOptions();
              updatePriorityHuman();
            });
          });

        formElem
          .querySelectorAll<HTMLInputElement>(
            ".sponsorships_form_booth_request input[type=checkbox]",
          )
          .forEach((boothCheckbox) => {
            boothCheckbox.addEventListener("change", () => {
              // Reset fallback option to remind user to select again
              fallbackOptionSelect.value = "";
              const prioritySection = formElem.querySelector<HTMLElement>(
                ".sponsorships_form_fallback_priority",
              );
              prioritySection?.classList.add("d-none");
              updateFallbackOptions();
            });
          });
      });

    const ENGLISH_REGEX =
      /^(?:[\p{Script=Latin}\p{Script=Zyyy}\p{Sc}\p{Sk}\p{Sm}\p{So}])*$/u;
    formElem.querySelectorAll(".sponsorships_form_info").forEach((elem) => {
      elem
        .querySelectorAll<HTMLInputElement>(
          'input[name="sponsorship[name]"], textarea[name="sponsorship[profile]"]',
        )
        .forEach((inputElem) => {
          const onChange = () => {
            const warningsToShow = new Map<string, boolean>();

            if (!ENGLISH_REGEX.test(inputElem.value)) {
              warningsToShow.set("english", true);
            }

            const warningElems = formElem.querySelectorAll<HTMLElement>(
              ".sponsorships_form_info__warning",
            );

            warningElems.forEach((w) => {
              if (warningsToShow.has(w.dataset.warningKind || "")) {
                w.classList.remove("d-none");
                w.querySelectorAll("input").forEach((i) => (i.required = true));
              } else {
                w.classList.add("d-none");
                w.querySelectorAll("input").forEach(
                  (i) => (i.required = false),
                );
              }
            });
          };
          inputElem.addEventListener("input", onChange);
          inputElem.addEventListener("change", onChange);
        });
    });
  });
});
